import { render } from "./IconHeading2.vue?vue&type=template&id=e275a77c&ts=true"
import script from "./IconHeading2.vue?vue&type=script&lang=ts"
export * from "./IconHeading2.vue?vue&type=script&lang=ts"

import exportComponent from "/app/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__